/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * Where the employee works during a clock-in stretch — chosen at clock-in by employees the
administration allows to work from home and stored on the clock-in only.
Null means "not asked" (on site, as before). Travels as an int on the wire — never renumber.
 */
export type FacilityFlowCoreModulesPlanningEntitiesWorkLocation = typeof FacilityFlowCoreModulesPlanningEntitiesWorkLocation[keyof typeof FacilityFlowCoreModulesPlanningEntitiesWorkLocation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesPlanningEntitiesWorkLocation = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
